import request from "@/utils/request";

// 获取路线路径列表
export function getRoutePathList() {
  return request({
    url: "/route/path-list",
    method: "get",
  });
}